import { Dayjs } from 'dayjs';
import RangePicker from './components/RangePicker.component';

interface ICustomDateRangePicker {
	name: string;
	dates: (Dayjs | null)[];
	error?: boolean;
	errorMessage?: string;
	setStartDate: React.Dispatch<React.SetStateAction<Dayjs | null>>;
	setEndDate: React.Dispatch<React.SetStateAction<Dayjs | null>>;
	onClose?: () => void;
}

const CustomDateRangePicker = ({
	name,
	dates,
	error,
	errorMessage,
	setStartDate,
	setEndDate,
	onClose,
}: ICustomDateRangePicker) => {
	const dateStart = dates[0];
	const dateEnd = dates[1];

	return (
		<RangePicker
			name={name}
			dateStart={dateStart}
			dateEnd={dateEnd}
			error={error}
			errorMessage={errorMessage}
			setStartDate={setStartDate}
			setEndDate={setEndDate}
			onClose={onClose}
		/>
	);
};

export default CustomDateRangePicker;
